export const fieldWrapperProps = {
    id: String,
    label: String,
    hint: String,
    error: String | Boolean,
    addOnBefore: String,
    addOnAfter: String,
    tooltip: String,
};
